import { useQuery } from '@tanstack/react-query'
import { msgHTTP } from '@/lib/msgHTTP'

type SentEmailResponse = {
  html?: string
  presignedUrl?: string
}

// Fetches the exact HTML of an email that was sent, by its Messaging log id
// (e.g. the FAN email referenced by an on-hold-history entry).
const useSentEmail = (logId: string | undefined, enabled: boolean) => {
  return useQuery<SentEmailResponse>({
    queryKey: ['sentEmail', logId],
    queryFn: () => msgHTTP.get(`/email/log/${logId}`),
    enabled: enabled && !!logId,
    // presignedUrl responses expire after ~10 minutes — refetch past that.
    staleTime: 5 * 60 * 1000
  })
}

export default useSentEmail
